module.exports = __webpack_public_path__ + "static/img/copper-ingot_256.e540a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copper-ingot_256.png
// module id = h+gf
// module chunks = 0